var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-grow-1" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "filter-label",
        _vm._b(
          { key: item.name + item.value, on: { remove: _vm.onRemove } },
          "filter-label",
          item,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }